export default {
  affiliate: {
    // Main navigation
    title: 'アフィリエイト',
    cantFindQuestion: '質問が見つかりませんか？',
    onlineService: 'オンラインサービス',
    dashboard: 'ダッシュボード',
    myRewards: 'マイリワード',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: '招待報酬',
    rules: 'ルール',

    // Team Info
    teamData: 'チームデータ',
    details: '詳細',
    totalValidFriends: '有効な友達の合計:',
    todayTotalWager: '今日の総ベット額:',
    rewards: '報酬',

    // Commission rates
    inviteFriendsCommissionUpTo: '友達招待コミッション最大',
    expandTeamBonus: 'チーム拡大ボーナス',
    maxLevelCommission: '最大レベルコミッション',
    inviteFriendsCommission: '友達招待コミッション',
    maxPerformanceCommission: '最大パフォーマンスコミッション',
    unlimitedAgent: '無制限エージェント',
    unlimitedCommission: '無制限コミッション',
    commissionRate: 'コミッション率',

    // Team Invite Friends
    inviteFriendsToEarn: '友達を招待して稼ぐ',
    link: 'リンク',
    code: 'コード',
    inviteFriends: '友達を招待',
    share: '共有',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: '請求',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: '今日受け取った',

    // Live Rewards
    liveRewards: 'ライブ報酬',
    sendTotalCommission: '総コミッションを送信',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: '今日招待した友達',
    todayDepositFriends: '今日入金した友達',
    depositFriends: '入金した友達',
    validFriends: '有効な友達',

    // Dialogs
    howMakeFriendsSubordinates: '友達を部下にする方法：',
    shareInvitationLink: '招待リンクを共有して登録してもらいます。',
    shareInvitationCode: '招待コードを共有して登録時に入力してもらいます。',
    shareQRCode: 'QRコードを共有してスキャンして登録してもらいます。',
    depositFriendsDescription: '部下の友達が入金に成功すると、入金友達になります。',
    howMakeFriendsValidUsers: '友達を有効ユーザーにする方法：',
    successfullyInviteFriends: '友達のサインアップ招待に成功。',
    cumulativeDepositsReach: '累積入金額が10.00 USDTに達する。',
    cumulativeValidBetsReach: '累積有効ベット額が50.00 USDTに達する。',
    thenBecomeValidUsers: 'その後、有効ユーザーになります。',

    // Share Dialog
    shareTitle: '共有',
    player: 'プレイヤー',
    saveImage: '画像を保存',
    saveImageSuccess: "画像を保存しました",
    saveImageFailed: "保存に失敗しました。もう一度お試しください",
    copy: 'コピー',
    copied: 'コピーしました！',

    // Received/Withdraw
    received: '受け取った',
    withdraw: '出金',
    history: '履歴',
    referralRewards: '紹介報酬',
    commission: 'コミッション',
    depositRebate: '入金リベート',
    levelUpRewards: 'レベルアップ報酬',
    loading: '読み込み中...',
    noMoreRecords: 'これ以上の記録はありません',
    loadMore: 'もっと読み込む',
    pending: '保留中',
    paid: '支払い済み',
    rejected: '拒否',
    unknown: '不明',
    upgradeReward: 'レベルアップ報酬',
    cancelled: 'キャンセル済み',
    receiving: '受け取り中',
    failed: '失敗',
    expired: '期限切れ',

    // History Dialog
    pickDate: '日付を選択',
    select: '選択',
    chooseBonus: 'ボーナスを選択',
    all: 'すべて',

    // Invitation Rewards Page
    inviteFriendToGet: '友達を招待して獲得',
    yourFriendGet: '友達が獲得',
    inviteFriendsEarnRewards: '友達を招待して報酬を獲得',
    dailyInvitations: '毎日の招待',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'アフィリエイト報酬を獲得する方法は？',
    shareToFriends: '友達に共有',
    shareReferralLink: '紹介リンク、コード、またはQRコードを友達と共有',
    friendsSignUpDeposit: '友達がサインアップして入金',
    inviteFriendsRegisterDeposit: '友達をAFUNに登録し、初回入金を行うよう招待します。',
    getUpTo: '最大獲得',
    earnBigRewards: '友達が賭け、入金、VIPに到達すると報酬とコミッションを獲得できます。',
    noticeEnsureCorrect: '注意：招待リンク、QRコード、またはコードが正しいことを確認してください。',

    // Rules - Commission Work
    howCommissionWork: 'コミッションの仕組みは？',
    agentRatingDescription: 'エージェント評価の説明',
    you: 'あなた',
    commissionDescription: '友達B、C、D以降の入金と賭けからコミッションを獲得できます。コミッション率は右の表をご覧ください。',
    claimConditions: '請求条件',
    teamLevel: 'チームレベル',
    earnUpTo: "Earn up to",
    expandYourTeam: "チームを拡大",
    earnAnExtra: "追加で獲得",
    upgradeAgentLevel: "エージェントレベルを上げる",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: '合計サイズ',
    teamWager: 'チームベット',
    rebateRewardVary: 'リベート報酬とトップアップ報酬は、その日のチームレベルによって異なります。',
    teamSizeDescription: 'チームサイズ：現在保有している有効ユーザー数。',
    teamBettingDescription: 'チームベット：部下が1日に行う賭けの総数。',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'チームコミッション',
    teamCommissionSubTitle: 'ネットワーク全体の入金と\n賭けごとに獲得できます。',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: '友達を招待すると、両方が報酬を受け取ります',
    inviteRegisterReceive: '友達の登録招待に成功して受け取る',
    friendDepositWagerUnlock: '友達が10.00 USDTを入金し、50.00 USDTを賭けると、3.00 USDTの報酬がアンロックされ、友達は2.00 USDTを獲得します。',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: '最近招待した友達',
    recentDepositFriends: '最近入金した友達',
    today: '今日',
    yesterday: '昨日',
    thisMonth: '今月',
    friendsData: '友達データ',
    joinDate: '参加日',
    search: '検索',
    level: 'レベル',
    tier: 'ティア',
    affiliateTreasureBox: 'アフィリエイト宝箱',
    referralRewardsDesc: '友達を招待して登録すると、あなたも友達も豪華なボーナスを受け取れます。',
    commissionDesc: 'あなたとチームが協力して目標を達成し、豪華なコミッションを獲得します。',
    affiliateTreasureBoxDesc: '友達を招待してマイルストーンボーナスを獲得',
  }
};
